export default [
  {
    path: '/materialsAudit/index',
    name: '竞赛材料审核',
    hidden: false,
    component: resolve => require(['@/views/Application.vue'], resolve),
    redirect: '/materialsAudit/index',
    meta: {
      title: '竞赛材料审核',
      icon: 'fa fa-star iconTitle',
      role: ['materials_audit'],
      level: 1
    },
    children: [
      {
        path: '/materialsAudit/index',
        name: 'materialsAudit',
        hidden: false,
        component: resolve =>
          require(['@/views/euc-staff/audit/materials'], resolve),
        meta: {
          title: '竞赛材料审核',
          icon: 'fa fa-star iconTitle',
          role: ['materials_audit'],
          level: 1
        }
      }
    ]
  },
  {
    path: '/signupReview',
    name: 'signupReview',
    hidden: true,
    component: resolve => require(['@/views/Application.vue'], resolve),
    redirect: '/signupReview/index',
    meta: {
      title: '参赛人员详情',
      icon: 'fa fa-star iconTitle',
      role: ['apply_audit'],
      level: 2
    },
    children: [
      {
        path: '/signupReview/index',
        name: 'signupReview',
        hidden: true,
        component: resolve =>
          require(['@/views/euc-staff/signupReview/index.vue'], resolve),
        meta: {
          title: '参赛人员详情',
          icon: 'fa fa-star iconTitle',
          role: ['apply_audit'],
          level: 2
        }
      }
    ]
  },
  {
    path: '/groupSignupReview',
    name: 'groupSignupReview',
    hidden: true,
    component: resolve => require(['@/views/Application.vue'], resolve),
    redirect: '/signupReview/index',
    meta: {
      title: '参赛人员详情',
      icon: 'fa fa-star iconTitle',
      role: ['apply_audit'],
      level: 2
    },
    children: [
      {
        path: '/groupSignupReview/index',
        name: 'groupSignupReview',
        hidden: true,
        component: resolve =>
          require(['@/views/euc-staff/signupReview/index.vue'], resolve),
        meta: {
          title: '参赛人员详情',
          icon: 'fa fa-star iconTitle',
          role: ['apply_audit'],
          level: 2
        }
      }
    ]
  },
  {
    path: '/leaderDetail',
    name: 'leaderDetail',
    hidden: true,
    component: resolve => require(['@/views/Application.vue'], resolve),
    redirect: '/signupReview/leaderDetail',
    meta: {
      title: '领队详情',
      icon: 'fa fa-star iconTitle',
      role: ['apply_audit'],
      level: 2
    },
    children: [
      {
        path: '/leaderDetail/index',
        name: 'leaderDetail',
        hidden: true,
        component: resolve =>
          require(['@/views/euc-staff/signupReview/leaderDetail.vue'], resolve),
        meta: {
          title: '领队详情',
          icon: 'fa fa-star iconTitle',
          role: ['apply_audit'],
          level: 2
        }
      }
    ]
  },
  {
    path: '/startList',
    name: '现场校验',
    component: resolve => require(['@/views/Application.vue'], resolve),
    redirect: '/startList/index',
    hidden: false,
    meta: {
      title: '现场校验',
      icon: 'fa fa-star iconTitle',
      role: ['scene_sign'],
      level: 1
    },
    children: [
      {
        path: '/startList/index',
        name: 'startList/index',
        hidden: false,
        component: resolve =>
          require(['@/views/euc-staff/calibration'], resolve),
        meta: {
          title: '现场校验',
          icon: 'fa fa-star iconTitle',
          role: ['scene_sign'],
          level: 1
        }
      }
    ]
  },
  // {
  //   path: '/judgmentSign',
  //   name: '评委签到',
  //   hidden: false,
  //   component: resolve => require(['@/views/Application.vue'], resolve),
  //   redirect: '/judgmentSign/index',
  //   meta: {
  //     title: '评委签到',
  //     icon: 'fa fa-star iconTitle',
  //     role: ['scene_sign']
  //   },
  //   children: [
  //     {
  //       path: '/judgmentSign/index',
  //       name: 'judgmentSign/index',
  //       hidden: false,
  //       component: resolve =>
  //         require(['@/views/euc-staff/sign/JudgeSign.vue'], resolve),
  //       meta: {
  //         title: '评委签到',
  //         icon: 'fa fa-star iconTitle',
  //         role: ['scene_sign']
  //       }
  //     }
  //   ]
  // },
  // {
  //   path: '/leaderSign',
  //   name: '领队签到',
  //   hidden: false,
  //   component: resolve => require(['@/views/Application.vue'], resolve),
  //   redirect: '/leaderSign/index',
  //   meta: {
  //     title: '领队签到',
  //     icon: 'fa fa-star iconTitle',
  //     role: ['scene_sign']
  //   },
  //   children: [
  //     {
  //       path: '/leaderSign/index',
  //       name: 'leaderSign/index',
  //       hidden: false,
  //       component: resolve =>
  //         require(['@/views/euc-staff/sign/LeaderSign.vue'], resolve),
  //       meta: {
  //         title: '领队签到',
  //         icon: 'fa fa-star iconTitle',
  //         role: ['scene_sign']
  //       }
  //     }
  //   ]
  // },
  // {
  //   path: '/judgmentAccount',
  //   name: '查看评委人员账号',
  //   hidden: false,
  //   component: resolve => require(['@/views/Application.vue'], resolve),
  //   redirect: '/judgmentAccount/index',
  //   meta: {
  //     title: '查看评委人员账号',
  //     icon: '',
  //     role: ['apply_audit', 'materials_audit']
  //   },
  //   children: [
  //     {
  //       path: '/judgmentAccount/index',
  //       name: 'judgmentAccount/index',
  //       hidden: false,
  //       component: resolve =>
  //         require(['@/views/euc-staff/sign/JudgeAccount.vue'], resolve),
  //       meta: {
  //         title: '查看评委人员账号',
  //         icon: 'fa fa-star iconTitle',
  //         role: ['apply_audit', 'materials_audit']
  //       }
  //     }
  //   ]
  // },
  {
    path: '/verifyContestantAttach',
    name: '参赛人员竞赛材料审核',
    hidden: true,
    redirect: '/verifyContestantAttach/index',
    component: resolve => require(['@/views/Application.vue'], resolve),
    meta: {
      title: '参赛人员竞赛材料审核',
      icon: '',
      role: ['materials_audit'],
      level: 2
    },
    children: [
      {
        path: 'index',
        name: 'verifyContestantAttach/index',
        hidden: true,
        component: resolve =>
          require([
            '@/views/euc-staff/compmanage/VerifyContestantAttach.vue'
          ], resolve),
        meta: {
          title: '参赛人员竞赛材料审核',
          icon: '',
          role: ['materials_audit'],
          level: 2
        }
      }
    ]
  },
  {
    path: '/checkVerifyContestantAttach',
    name: '参赛人员竞赛材料查看',
    hidden: true,
    redirect: '/checkVerifyContestantAttach/index',
    component: resolve => require(['@/views/Application.vue'], resolve),
    meta: {
      title: '参赛人员竞赛材料查看',
      icon: '',
      role: ['materials_audit'],
      level: 2
    },
    children: [
      {
        path: 'index',
        name: 'checkVerifyContestantAttach/index',
        hidden: true,
        component: resolve =>
          require([
            '@/views/euc-staff/compmanage/VerifyContestantAttach.vue'
          ], resolve),
        meta: {
          title: '参赛人员竞赛材料查看',
          icon: '',
          role: ['materials_audit'],
          level: 2
        }
      }
    ]
  },
  // {
  //   path: '/competitionList',
  //   name: '出场名单',
  //   hidden: true,
  //   redirect: '/competitionList/index',
  //   component: resolve => require(['@/views/Application.vue'], resolve),
  //   meta: {
  //     title: '出场名单',
  //     icon: 'fa fa-star iconTitle',
  //     role: ['scene_sign']
  //   },
  //   children: [
  //     {
  //       path: 'index',
  //       name: 'competitionList/index',
  //       hidden: true,
  //       component: resolve =>
  //         require([
  //           '@/views/euc-staff/calibration/CompetitionList.vue'
  //         ], resolve),
  //       meta: {
  //         title: '出场名单',
  //         icon: 'fa fa-star iconTitle',
  //         role: ['scene_sign']
  //       }
  //     }
  //   ]
  // },
  {
    path: '/signAudit',
    name: '报名审核',
    hidden: false,
    redirect: '/signAudit/index',
    component: resolve => require(['@/views/Application.vue'], resolve),
    meta: {
      title: '报名审核',
      icon: 'fa fa-star iconTitle',
      role: ['apply_audit'],
      level: 1
    },
    children: [
      {
        path: '/signAudit/index',
        name: 'index',
        hidden: false,
        component: resolve =>
          require(['@/views/euc-staff/audit/sign/single'], resolve),
        meta: {
          title: '报名审核',
          icon: 'fa fa-star iconTitle',
          role: ['apply_audit'],
          level: 1
        }
      }
    ]
  },
  {
    path: '/groupAudit',
    name: '报名审核',
    hidden: false,
    redirect: '/groupAudit/index',
    component: resolve => require(['@/views/Application.vue'], resolve),
    meta: {
      title: '报名审核',
      icon: 'fa fa-star iconTitle',
      role: ['apply_audit'],
      level: 1
    },
    children: [
      {
        path: '/groupAudit/index',
        name: 'index',
        hidden: false,
        component: resolve =>
          require(['@/views/euc-staff/audit/sign/group'], resolve),
        meta: {
          title: '报名审核',
          icon: 'fa fa-star iconTitle',
          role: ['apply_audit'],
          level: 1
        }
      }
    ]
  },
  {
    path: '/unionPlayers',
    name: '工会组队报名详情',
    hidden: true,
    redirect: '/unionPlayers',
    component: resolve => require(['@/views/Application.vue'], resolve),
    meta: {
      title: '工会组队报名详情',
      icon: 'fa fa-star iconTitle',
      role: ['apply_audit'],
      level: 2
    },
    children: [
      {
        path: '/unionPlayers',
        name: '工会组队报名详情',
        hidden: true,
        component: resolve =>
          require(['@/views/euc-staff/audit/sign/group/PlayerList'], resolve),
        meta: {
          title: '工会组队报名详情',
          icon: 'fa fa-star iconTitle',
          role: ['apply_audit'],
          level: 2
        }
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/euc-staff/index.js